import React, { Component } from "react";
import { fetchLocationMaps } from "LocationMapActions";
import { fetchInteractiveMaps } from "InteractiveMapAction";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import LocationMapItem from "./location-map-item";
import { Col, Row, Container } from "react-bootstrap";
import NoContent, { NO_MAP } from "NoContent";
import LocaleStrings from "Languages";

class MapList extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    setTimeout(() => {
      this.props.actions.fetchLocationMaps(this.props.session, (callback) => {
        this.props.actions.fetchInteractiveMaps(
          this.props.session,
          (callback) => {}
        );
      });
    }, 400);
  }

  renderLocationMapList() {
    var items = _.map(this.props.locationmaps, (locationmap, index) => {
      //var x = index % 4;
      //var y = Math.floor(index / 4);
      return (
        <Col
          sm={4}
          md={3}
          lg={3}
          key={locationmap.mapid}
          style={{ width: "auto" }}
        >
          <LocationMapItem locationmap={locationmap} is_locationmap={true} />
        </Col>
      );
    });

    return items;
  }

  renderInteractiveMapList() {
    var items = _.map(this.props.interactivemaps, (interactivemap, index) => {
      //var x = index % 4;
      //var y = Math.floor(index / 4);
      return (
        <Col
          sm={4}
          md={3}
          lg={3}
          key={interactivemap.interactivemapid}
          style={{ width: "auto" }}
        >
          <LocationMapItem
            locationmap={interactivemap}
            is_locationmap={false}
          />
        </Col>
      );
    });

    return items;
  }

  render() {
    var showLocationMaps = this.props.locationmaps.length > 0;
    var showInteractiveMaps = this.props.interactivemaps.length > 0;
    var noMap = !showLocationMaps && !showInteractiveMaps;
    let { deviceSize } = this.props;
    return (
      <div
        className="sponsor-content scrollable-content"
        style={{ height: deviceSize.height - 163, padding: 18 }}
      >
        {showLocationMaps ? (
          <div>
            <div className="map-list-title">
              {LocaleStrings.map_locationmap}
            </div>
            <Container fluid={true}>
              <Row className="show-grid">{this.renderLocationMapList()}</Row>
            </Container>
          </div>
        ) : noMap ? (
          <NoContent contentType={NO_MAP} />
        ) : (
          ""
        )}
        {showInteractiveMaps && showLocationMaps ? (
          <div className="h-divider"></div>
        ) : (
          ""
        )}
        {showInteractiveMaps ? (
          <div>
            <div className="map-list-title">
              {LocaleStrings.map_interactive}
            </div>
            <Container fluid={true}>
              <Row className="show-grid">{this.renderInteractiveMapList()}</Row>
            </Container>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    locationmaps: state.locationMaps,
    session: state.session,
    interactivemaps: state.interactiveMaps,
    deviceSize: state.deviceSize,
  };
}

var bindActionsToProps = (dispatch) => ({
  actions: bindActionCreators(
    { fetchLocationMaps, fetchInteractiveMaps },
    dispatch
  ),
});

export default connect(mapStateToProps, bindActionsToProps)(MapList);
